import React from 'react';
import SpinnerProps from './Spinner.types';
import styles from './Spinner.module.scss';
import Icon from '../Icon';

const Spinner = ({ className, dataCy = 'spinner' }: SpinnerProps) => (
  <Icon
    dataCy={dataCy}
    icon='spinner'
    className={`${styles.spinner} ${className}`}
    title='spinner'
    viewBox='0 0 1024 1024'
    fill='currentColor'
  />
);

export default Spinner;
